var map = {
	"./bg_hover.png": "63f3",
	"./bg_pre.png": "4fa8",
	"./documentTranslationIcon.png": "33f7",
	"./gut_logo.png": "b4e5",
	"./gx_logo.png": "77e5",
	"./icon-audit-records.png": "6470",
	"./icon-filemanage.png": "11a0",
	"./icon-homework.png": "71bc",
	"./icon-memory.png": "105e",
	"./icon-retrieval.png": "f328",
	"./icon-term.png": "594c",
	"./icon-test.png": "5f92",
	"./icon_job_management.png": "04fb",
	"./icon_library.png": "8022",
	"./icon_mission.png": "fb76",
	"./icon_projectManagement.png": "5b53",
	"./icon_tatistics.png": "7e83",
	"./icon_teamManagement.png": "0b29",
	"./intelligentTranslationIcon.png": "5577",
	"./kgd_logo.png": "d811",
	"./logo.png": "b669",
	"./my_project.png": "7656",
	"./mz_logo.png": "5532",
	"./pro_logo.png": "3ce9",
	"./textTranslationIcon.png": "d8cf",
	"./yl_logo.png": "05ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "42dd";